import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { PatternBookCustomer } from '../../../models';
import { TmsWebBaseService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class PatternBookCustomerService extends TmsWebBaseService {
  constructor() {
    super('PatternBookCustomer');
  }

  getAllCustomersForPatternBook(productId: string): Observable<PatternBookCustomer[]> {
    return this.httpService.get<PatternBookCustomer[]>(`${this.apiUrl}/GetAllCustomersForPatternBook/${productId}`);
  }

  updatePatternBookCustomers(productId: string, customerIds: string[]): Observable<void> {
    return this.httpService.post(`${this.apiUrl}/UpdatePatternBookCustomers`, { productId, customerIds });
  }
}
